module.exports = __webpack_public_path__ + "img/OFFICEENVIRONMENT.273fb029.png";